import { useCallback } from 'react';
import { Box, Divider } from '@material-ui/core';
import { QuoteShareLink } from '@setvi/shared/interfaces';
import { Header } from '@setvi/shared/components/sdrawer-content/components/header';
import { Subheader } from '../../../components/subheader';
import { LinkForm } from '../../../components/link-form';
import { ReviewLinkMenu } from '../menu';

interface QuoteLinkEditProps {
  quoteLink: QuoteShareLink;
  handleBack: () => void;
  handleClose: () => void;
  handleDelete: () => void;
}

/**
 * Renaming the quote share link from the drawer.
 *
 * The resource-link page next to this one also lists the resources inside the
 * link and lets them be removed; a quote share has none, so this is that page
 * without the middle — the same "Link Name" field and Update Link button
 * (DEV-785).
 */
export const QuoteLinkEdit = ({
  quoteLink,
  handleBack,
  handleClose,
  handleDelete
}: QuoteLinkEditProps) => {
  const onPreview = useCallback(
    () => window.open(quoteLink?.href, '_blank')?.focus(),
    [quoteLink?.href]
  );

  return (
    <Box height="100%" display="flex" flexDirection="column" minHeight={0}>
      <Header title="Edit & Rename Link(s)" handleClose={handleClose} />
      <Subheader
        handleBack={handleBack}
        text={quoteLink?.name}
        customAction={
          <ReviewLinkMenu onPreview={onPreview} onDelete={handleDelete} />
        }
      />
      <Box mt="auto">
        <Divider />
        <LinkForm
          handleSubmit={name => quoteLink?.rename(name)}
          handleClose={handleBack}
          initialValue={quoteLink?.name || ''}
          submitText="Update Link"
        />
      </Box>
    </Box>
  );
};
